import Skeleton from "../base"

const ConversationsListSkeleton = () => (
  <Skeleton>
    <ul className="divide-y divide-neutral-200 overflow-y-auto">
      {Array.from({ length: 10 }).map((_, index) => (
        <li key={index} className="py-3 px-4 flex items-center justify-between">
          <div className="flex flex-1">
            <div className="min-w-8 h-8 bg-gray-200 rounded-full"></div>
            <div className="ml-3 mx-auto max-w-sm w-full">
              <div className="flex">
                <div className="w-20 h-4 bg-gray-200 rounded-full"></div>
                <div className="w-16 h-4 bg-gray-100 rounded-full ml-auto"></div>
              </div>
              <div className="w-36 h-3 bg-gray-200 rounded-full mt-2"></div>
              <div className="w-16 h-4 bg-gray-100 rounded-full mt-2"></div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  </Skeleton>
)

export default ConversationsListSkeleton
